import { type IAnalyticEventsConfig } from "@magnit/analytic-events/src/manager";

export const catalogListingEvents: IAnalyticEventsConfig = {
  "CatalogListing:List:View": {
    ya: {
      eventName: "catalogCategory_view",
      page: "catalogCategory",
    },
  },
  "CatalogListing:Item:Click": {
    ya: {
      eventName: "catalogCategory_item_click",
      page: "catalogCategory",
      element: "item",
    },
  },
  "CatalogListing:Item:View": {
    ya: {
      eventName: "catalogCategory_item_view",
      page: "catalogCategory",
      element: "item",
    },
  },
  "CatalogListing:Sort:View": {
    ya: {
      eventName: "catSort_view",
      page: "catSort",
    },
  },
  "CatalogListing:Sort:Click": {
    ya: {
      eventName: "catalogCategory_sort_click",
      page: "catalogCategory",
      element: "sort",
    },
  },
  "CatalogListing:Sort:Variant:Click": {
    ya: {
      eventName: "catSort_variant_click",
      page: "catSort",
      element: "variant",
    },
  },
  "CatalogListing:ShowMore:View": {
    ya: {
      eventName: "catalogCategory_more_view",
      page: "catalogCategory",
      element: "more",
    },
  },
  "CatalogListing:ShowMore:Click": {
    ya: {
      eventName: "catalogCategory_more_click",
      page: "catalogCategory",
      element: "more",
    },
  },
  "CatalogListing:Pagination:Click": {
    ya: {
      eventName: "catalogCategory_pag_item_click",
      page: "catalogCategory",
      block: "pag",
      element: "item",
    },
  },
  "Catalog:Categories:View": {
    ya: {
      eventName: "catalog_view",
      page: "catalog",
    },
  },
  "Catalog:Categories:Listing:View": {
    ya: {
      eventName: "catalogCategory_view",
      page: "catalogCategory",
    },
  },
  "Catalog:Categories:Item:Click": {
    ya: {
      eventName: "catalog_subdir_category_click",
      page: "catalog",
      block: "subdir",
      element: "category",
    },
  },
  "Catalog:Categories:All:Click": {
    ya: {
      eventName: "catalog_subdir_allGoods_click",
      page: "catalog",
      block: "subdir",
      element: "allGoods",
    },
  },
  "Catalog:Categories:Button:Back:Click": {
    ya: {
      eventName: "catalogCategory_buttonBack_click",
      page: "catalogCategory",
      element: "buttonBack",
    },
  },
};
